"use strict";
// Copyright (c) StrangeBee 2024
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentController = void 0;
var AttachmentController_1 = require("./AttachmentController");
Object.defineProperty(exports, "AttachmentController", { enumerable: true, get: function () { return __importDefault(AttachmentController_1).default; } });
